import { render, staticRenderFns } from "./CustomReferenceModal.vue?vue&type=template&id=7401a050&scoped=true"
import script from "./CustomReferenceModal.vue?vue&type=script&lang=js"
export * from "./CustomReferenceModal.vue?vue&type=script&lang=js"
import style0 from "./CustomReferenceModal.vue?vue&type=style&index=0&id=7401a050&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7401a050",
  null
  
)

export default component.exports